/**
 * Included into the footer of pages.
 */

import variables from './variables';
import './lib/AnimationEasing';
import "./lib/AnalyticsSetup";
import onDocumentLoaded from './lib/onDocumentLoaded';

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import {MainMenu, CollapseExpandChildrenListener} from './component/MainMenu';
new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.nav--primary.mobile > .node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen',
	},
	listeners: [
		new CollapseExpandChildrenListener(400, 'easeOutExpo')
	]
});



//===================================================================
// Carousel Masthead
//===================================================================
// import entryVideo from './component/entryVideo';
// entryVideo('.featureCarousel__videoWrap');

import {FeatureCarousel} from './component/FeatureCarousel';
const entryCarouselEl = document.querySelector<HTMLElement>('.featureCarousel');
if (entryCarouselEl) {
	new FeatureCarousel({
		analyticsCategory: 'Feature Carousel',
		carouselClass: 'featureCarousel',
		carouselEl: entryCarouselEl,
		duration: 6000, /* NOTE: if updating this value, update animation duration in CSS */
		doIndicatorClick: true,
	});
}
//===================================================================


//===================================================================
// Video - Lightbox
//===================================================================
import VideoLightbox from './component/VideoLightbox';
VideoLightbox();
//===================================================================


//===================================================================
// Warranty Form Lightbox
//===================================================================
import WarrantyFormLightbox from './component/WarrantyFormLightbox';
WarrantyFormLightbox();
//===================================================================


//===================================================================
// To fix scrollbar widths issue on Full Width blocks.
//===================================================================
import './lib/SetScrollBarWidthProperty';
//===================================================================


//===================================================================
// History Timeline - Pagination Functionality
//===================================================================
// import './lib/History-Timeline';
// import './component/HistoryTimeline';
//===================================================================

import "./component/literature-display-style";

import "./component/warranty-form-conditional-logic";

//===================================================================



// ---------------------------------------------------------------------------------------------- //
// Masthead Video Play/Pause
// ---------------------------------------------------------------------------------------------- //
onDocumentLoaded(() => {
	for (const videoIcon of document.querySelectorAll("#videoIcon")) {
		const video = videoIcon.closest(".wp-block-masthead-video")?.querySelector<HTMLMediaElement>("#videoBg");
		if (!video) {
			continue;
		}
		const updateVideoIcon = () => {
			videoIcon.classList.toggle('icon--play', video.paused);
			videoIcon.classList.toggle('icon--pause', !video.paused);
			videoIcon.ariaLabel = video.paused ? "Play button" : "Pause button";
			videoIcon.ariaPressed = video.paused ? "false" : "true";
		}

		videoIcon.addEventListener('click', () => {
			if (video.paused) {
				video.play();
			} else {
				video.pause();
			}
		});

		video.addEventListener('pause', updateVideoIcon);
		video.addEventListener('play', updateVideoIcon);

		updateVideoIcon();
	}
});



// ---------------------------------------------------------------------------------------------- //
// Animations
//
// SEE EXAMPLE BELOW:
//
// import InViewObserver from './lib/InViewObserver';
// InViewObserver.createInstance([
// 	{
// 		observeSelector: '.pageContent > .wp-block-group, .callToAction, .pageFooter__content',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	},
// 	{
// 		observeSelector: '.decorativeShape__canvas, .pageFooter__donutCanvas',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	}
// ]);
// ---------------------------------------------------------------------------------------------- //



//=========================================================================
// Checks if Redirect Variable exists, if so, play the video in a lightbox
//=========================================================================

//=========================================================================
